/* src/app/components/payroll/corrections/cheque-void/cheque-void.component.css */
.table-style {
  width: 100%;
}
.filter-row {
  align-items: flex-end;
  margin-bottom: 12px;
}
.filter-actions {
  display: flex;
  gap: 8px;
}
.error-message {
  color: red;
  font-size: 12px;
  margin-bottom: 4px;
  display: block;
}
.error-message1 {
  color: red;
  font-size: 12px;
}
.field-header {
  font-size: 12px;
}
.ant-form-item {
  margin-bottom: 10px !important;
}
/*# sourceMappingURL=cheque-void.component-OL3AV36L.css.map */
